import React, { useState } from 'react'
import { Link } from 'gatsby'
import Centered from 'shared/ui/Centered'
import Tiles from 'shared/ui/Tiles'
// import Notice from 'shared/ui/Notice'
import TweetEmbed from 'shared/ui/TweetEmbed'
import tweetIds from '../data/tweetIds'
import Icon from 'shared/ui/Icon'
import Card from '../ui/Card'
import Heading from 'shared/ui/Heading'
import ContentTile from 'shared/ui/ContentTile'
import { Hero, HeroPrimaryContent } from '../ui/Hero'
import WorkshopListings from '../ui/public-workshops/WorkshopListings'
import { SlantBackground, SlantBackgroundImage } from '../ui/SlantBackground'
import { NewsletterSubscribeSection } from '../ui/NewsletterSubscribeForm'

export default function PublicWorkshops() {
  const [loadMoreTweets, setLoadMoreTweets] = useState(false)

  return (
    <div className="spacing-giant">
      <Hero>
        <HeroPrimaryContent>
          <div className="spacing">
            <Heading className="text-color-blue">
              <span className="text-xlarge">Public Workshops</span>
            </Heading>
            <div className="text-large">Attend our workshops remotely</div>
          </div>
          <p>
            Learn React topics from the ground up with our live workshop format designed for
            beginners and for those with a few years experience alike.
          </p>
          <p className="text-xsmall">Get notified when new workshops are available:</p>
          <div>
            <Link to="/newsletter" className="button icon-text">
              <Icon name="arrow-right" size={2} color="white" />
              <span>Get Notified</span>
            </Link>
          </div>
        </HeroPrimaryContent>
      </Hero>

      <SlantBackground verticalOffset={-7} shallowSlant>
        <SlantBackgroundImage src="/images/react-gray-two.svg" />
      </SlantBackground>

      <Centered>
        <div className="spacing-giant">
          <section className="offset-slant-background-image-left spacing-small">
            <Heading size={3}>Upcoming Public Workshops</Heading>

            <p className="text-small">
              If you have a group of about 6 or more people, we recommend our{' '}
              <Link to="/corporate-training">Corporate Training.</Link> You'll be able to choose a
              time that works for you and even request curriculum adjustments.
            </p>

            <WorkshopListings />
          </section>
          <section>
            <Tiles minSize={19} gutter={2}>
              <ContentTile title="React Workshop" iconName="react-color" iconColor="blue">
                <p className="text-small">
                  React is known for making UI components, but in a professional React app a
                  component is used for so much more. We'll teach your team how to use React's
                  components for scalable, accessible and reusable abstractions. Also{' '}
                  <Link to="/what-are-react-hooks">What are Hooks?</Link>
                </p>
              </ContentTile>
              <ContentTile title="JavaScript & Node Workshop" iconName="javascript-color">
                <p className="text-small">
                  Do you need catch up on some of the latest things happening in JavaScript? We've
                  got you covered. We have some <Link to="/learn">free content</Link> and we can
                  spend as much or as little time as you need during a React or a Node workshops.
                </p>
              </ContentTile>
            </Tiles>
          </section>

          <Card className="spacing-large">
            <div className="brands text-small">
              <Link
                to="/brands"
                className="brands-img-link"
                aria-label="See the brands that trust us"
              >
                <img src="/images/brands/apple.svg" title="Apple" alt="Apple" loading="lazy" />
                <img src="/images/brands/google.svg" title="Google" alt="Google" loading="lazy" />
                <img src="/images/brands/adobe.svg" title="Adobe" alt="Adobe" loading="lazy" />
                <img src="/images/brands/hp.svg" title="HP" alt="HP" loading="lazy" />
                <img
                  src="/images/brands/netflix.svg"
                  title="Netflix"
                  alt="Netflix"
                  loading="lazy"
                />
                <img
                  src="/images/brands/microsoft.svg"
                  title="Microsoft"
                  alt="Microsoft"
                  loading="lazy"
                />
                <img
                  src="/images/brands/starbucks.svg"
                  title="Starbucks"
                  alt="Starbucks"
                  loading="lazy"
                />
                <img src="/images/brands/paypal.svg" title="PayPal" alt="PayPal" loading="lazy" />
                <img src="/images/brands/slack.svg" title="Slack" alt="Slack" loading="lazy" />
                <img
                  src="/images/brands/walmart.svg"
                  title="Walmart"
                  alt="Walmart"
                  loading="lazy"
                />
                <img src="/images/brands/github.svg" title="Github" alt="GitHub" loading="lazy" />
                <img src="/images/brands/pixar.svg" title="Pixar" alt="Pixar" loading="lazy" />
                <img
                  src="/images/brands/mozilla.svg"
                  title="Mozilla"
                  alt="Mozilla"
                  loading="lazy"
                />
                <img
                  src="/images/brands/code-cademy.svg"
                  title="Code Cademy"
                  alt="Code Cademy"
                  loading="lazy"
                />
                <img src="/images/brands/uber.svg" title="Uber" alt="Uber" loading="lazy" />
                <img
                  src="/images/brands/verizon.svg"
                  title="Verizon"
                  alt="Verizon"
                  loading="lazy"
                />
                <img src="/images/brands/airbnb.svg" title="Airbnb" alt="Airbnb" loading="lazy" />
                <img src="/images/brands/indeed.svg" title="Indeed" alt="Indeed" loading="lazy" />
                <img src="/images/brands/lego.svg" title="Lego" alt="Lego" loading="lazy" />
                <img
                  src="/images/brands/the-washington-post.svg"
                  title="The Washington Post"
                  alt="The Washington Post"
                  loading="lazy"
                />
              </Link>
            </div>
            <div className="align-center text-small">
              <Link to="/brands">Trusted by these brands and more</Link>
            </div>
          </Card>
        </div>
      </Centered>

      <SlantBackground slantRight verticalOffset={-14} />

      <Centered>
        <div className="spacing-giant">
          <section>
            <p className="align-center">See what others have said after taking our workshops:</p>
            <Tiles gutter={1} minSize={17}>
              {tweetIds.slice(0, 4).map((id) => (
                <TweetEmbed
                  options={{
                    dnt: true,
                    cards: 'hidden',
                    conversation: 'none',
                  }}
                  id={id}
                  key={id}
                />
              ))}
              {loadMoreTweets &&
                tweetIds.slice(4).map((id) => (
                  <TweetEmbed
                    options={{
                      dnt: true,
                      cards: 'hidden',
                      conversation: 'none',
                    }}
                    id={id}
                    key={id}
                  />
                ))}
            </Tiles>
            {!loadMoreTweets && (
              <div className="align-center">
                <button onClick={() => setLoadMoreTweets(true)} className="button">
                  Load More Testimonials
                </button>
              </div>
            )}
          </section>
          <hr />
          <NewsletterSubscribeSection />
        </div>
      </Centered>
    </div>
  )
}
